import { execute_generator } from './networking/index'
import axios from 'axios'

const account_url = process.env.VUE_APP_API_ACCOUNT_URL
const client = axios.create({
    baseURL: account_url,
    json: true
})

export default {
    async execute (method, resource, data) {
        let accessToken = localStorage.getItem('jwt');
        return client({
            method,
            url: resource,
            data,
            headers: {
                Authorization: `Bearer ${accessToken}`
            }
        }).then(req => {
            return req.data
        })
    },
    getAccounts () {
        return this.execute('get', '/accounts/all')
    },
    getAccount (id) {
        return this.execute('get', `/accounts/${id}`)
    },
    createAccount (data) {
        return this.execute('post', '/accounts/create', data)
    },
    updateAccount (id, data) {
        return this.execute('put', `/accounts/${id}`, data)
    },
    deleteAccount (id) {
        return this.execute('delete', `/accounts/${id}`)
    },
    getAllAddresses () {
        return this.execute('get', '/accounts/addresses/all')
    },
    getAddress (id) {
        return this.execute('get', `/accounts/addresses/${id}`)
    },
    getAddressByAccount (accountId) {
        return this.execute('get', `/accounts/addresses/byacct/${accountId}`)
    },
    createAddress (data) {
        return this.execute('post', '/accounts/addresses/create', data)
    },
    updateAddress (id, data) {
        return this.execute('put', `/accounts/addresses/${id}`, data)
    },
    deleteAddress (id) {
        return this.execute('delete', `/accounts/addresses/${id}`)
    },
    getBillingInfo (id) {
        return this.execute('get', `/accounts/billing/${id}`)
    },
    updateBillingInfo (id, data) {
        return this.execute('put', `/accounts/billing/${id}`, data)
    },
    replaceStripeCard (data) {
        return this.execute('post', `/accounts/billing/replace`, data)
    },
    generateStripeCustomer (data) {
        return this.execute('post', '/accounts/customer/generate', data)
    },
    searchAccounts: (payload) => execute_generator('post', {service: account_url, resource:'/accounts/search'}, payload)   
}
